import { PricingTrackerService } from "@entities/PricingTracker/lib/services/pricing.tracker.service";
import { useQuery } from "@tanstack/react-query";
import { BRIEF_PRICING_AGGREGATE_QUERY_KEY } from "../constants";
import { PricingWorkloadService } from "../services/PricingWorkload.service";

export default function useGetBriefPricingAggregate({
  briefId,
  enabled,
}: {
  briefId: string;
  enabled: boolean;
}) {
  const { data, isLoading, error } = useQuery({
    queryKey: BRIEF_PRICING_AGGREGATE_QUERY_KEY(briefId),
    queryFn: () => PricingWorkloadService.getBriefPricing(briefId),
    enabled,
  });

  return {
    briefPricingAggregateData: data,
    isBriefPricingAggregateLoading: isLoading,
    error: error,
  };
}
